import { connect } from 'react-redux';
import { DRAFT } from 'shared/abilities';
import { isDrafting, makeDraft } from 'web/store/modules/pages';
import withUserAuth from '../hocs/withUserAuth';
import DraftButton from '../components/DraftButton';

const mapStateToProps = state => ({
  page: state.pageBuilder,
  drafting: isDrafting(state),
});

const mapDispatchToProps = null;

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;
  const { userIsAuthorized, ...restOfOwnProps } = ownProps;
  const { page, ...restOfStateProps } = stateProps;

  const authorized = userIsAuthorized({ action: 'manage', subject: DRAFT });

  const hide = !authorized || !page || !page.live;
  const onClick = () => dispatch(makeDraft(page));
  const overlayText = 'Making this page a draft will remove it from your live site.';

  return {
    ...restOfOwnProps,
    ...restOfStateProps,
    hide,
    onClick,
    overlayText,
  };
};

export default withUserAuth(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  )(DraftButton),
);
